import { Dispatch, SetStateAction, useMemo, useState } from "react";
import * as s from "../InputPage.styles";
import * as t from "./tractor.styles";
import AccessoryPickerModal from "./AccessoryPickerModal";
import { AnalysisForm } from "../machine";
import styled from "styled-components";
import { formatWonToEokMan } from "../function";

interface Props {
  formData: AnalysisForm;
  setFormData: Dispatch<SetStateAction<AnalysisForm>>;
}

function AccessorySection({ formData, setFormData }: Props) {
  const [openAccessoryPicker, setOpenAccessoryPicker] = useState(false);

  const totalCnt = useMemo(() => {
    return formData.implementList.reduce((sum, item) => sum + item.units, 0);
  }, [formData.implementList]);

  const totalCost = useMemo(() => {
    return formData.implementList.reduce(
      (sum, item) => sum + item.price * 10000 * item.units,
      0
    );
  }, [formData.implementList]);

  const totalMaintenance = useMemo(() => {
    return formData.implementList.reduce(
      (sum, item) => sum + item.maintenance * 10000 * item.units,
      0
    );
  }, [formData.implementList]);

  return (
    <s.Section>
      <s.SectionTitleContainer>
        <s.SectionTitle>2. 부속기</s.SectionTitle>
        {formData.implementList.length > 0 && (
          <t.EditButton
            onClick={() => {
              setOpenAccessoryPicker(true);
            }}
          >
            편집
          </t.EditButton>
        )}
      </s.SectionTitleContainer>
      <s.SectionInner $top={8}>
        <t.SelectedSection>
          {formData.implementList.length > 0 && (
            <t.SelectedList>
              {formData.implementList.map((i) => (
                <Item key={i.implement}>
                  <ItemTitle>{i.implement}</ItemTitle>
                  <ItemRight>
                    <ItemCount>{i.units}대</ItemCount>
                    <img src={`/asset/images/check/check-on.svg`} alt="" />
                  </ItemRight>
                </Item>
              ))}
            </t.SelectedList>
          )}
          <s.AddButton onClick={() => setOpenAccessoryPicker(true)}>
            <img src="/asset/images/icon/plus.svg" alt="" />
            <span>보유 중인 트랙터 부속기를 추가해주세요</span>
          </s.AddButton>
        </t.SelectedSection>
      </s.SectionInner>
      <s.SectionInner $top={8}>
        <t.RowContent>
          <t.TotalContentItem>
            <div className="item-label">총 부속기</div>
            <div className="item-value">{totalCnt}대</div>
          </t.TotalContentItem>
        </t.RowContent>
        <t.RowContent>
          <t.TotalContentItem>
            <div className="item-label">총 구입비</div>
            <div className="item-value">{formatWonToEokMan(totalCost)}</div>
          </t.TotalContentItem>
          <t.TotalContentItem>
            <div className="item-label">총 유지비</div>
            <div className="item-value">
              {formatWonToEokMan(totalMaintenance)}
            </div>
          </t.TotalContentItem>
        </t.RowContent>
      </s.SectionInner>
      {openAccessoryPicker && (
        <AccessoryPickerModal
          formData={formData}
          setFormData={setFormData}
          onClose={() => setOpenAccessoryPicker(false)}
        />
      )}
    </s.Section>
  );
}

export default AccessorySection;

const Item = styled.div`
  padding: 12px;
  display: flex;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  border-radius: 8px;
  background: var(--Alias-Color-Text-White-Gray-LightGray-100, #f7f8f9);
`;

const ItemTitle = styled.div`
  flex: 1 0 0;
  color: var(--Alias-Color-Text-Dark-Text-Primary, #171e26);
  font-feature-settings:
    "liga" off,
    "clig" off;

  /* Mo/Body/L-16-Bold */
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%; /* 24px */
`;

const ItemRight = styled.div`
  display: flex;
  padding: 8px;
  align-items: center;
  gap: 8px;
`;

const ItemCount = styled.div`
  color: var(--Alias-Color-Button-cta-light-background-Primary, #1e9b6b);
  text-align: center;
  font-feature-settings:
    "liga" off,
    "clig" off;

  /* Mo/Body/L-16-Bold */
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%; /* 24px */
`;
